import { HashLink as Link } from "react-router-hash-link";
import "./Header.css";

const Header = () => {
  window.addEventListener("scroll", function () {
    const navbar = document.querySelector(".navbar");
    navbar.classList.toggle("active", window.scrollY > 100);
  });

  return (
    <nav className="navbar navbar-expand-lg navbar-light fixed-top">
      <div className="container">
        <Link to="/" className="navbar-brand">
          Ahmad Subaktagin Jabir
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/home#">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/home#about">
                About Me
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/home#skills">
                Skills
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/home#projects">
                Projects
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/home#extra">
                Extra Curricular
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/home#contact">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
